<template>
  <div class="product-superiority rn-section-gap slider-bg-image"
    :style="{ 'background-image': `url(${require('@/assets/images/ProductService/common/product-superiority.png')})`,'background-attachment': 'fixed' }">
    <SectionTitle
      :title="$t('product.product_advantages')"
      description="PRODUCT ADVANTAGES"
      textAlign="center"
      />
    <div class="container">
        <div 
          class="row gx-5"
          :class="[
            getGroupedData.length === 1 ? '' : (index % 2 === 0 ? 'offset-md-1' : 'offset-left'),
            !isMobile ? 'p-4' : ''
          ]"
          v-for="(item, index) in getGroupedData" :key="index" >
              <div class="col-12 col-sm-6 mt--20 ">
                <superiorityContent v-if="item[0].text && item[0].text != ''" :contentData="item[0]"/>
                <superiorityOnlyTitle v-else :contentData="item[0]" />
              </div>
              <div class="col-12 col-sm-6 mt--20 ">
                <superiorityContent v-if="item[1].text && item[1].text != ''" :contentData="item[1]"/>
                <superiorityOnlyTitle v-else :contentData="item[1]" />
              </div>
        </div>
    </div>


  </div>
</template>

<script>
    import superiorityOnlyTitle from './superiorityOnlyTitle.vue'
    import superiorityContent from './superiorityContent.vue'
    import SectionTitle from '../../../../components/elements/sectionTitle/SectionTitle.vue'


    export default {
        name: 'ProductSuperiority',
        components: {
          superiorityOnlyTitle,superiorityContent,SectionTitle
        },
        props:{
          'productSuperiorityData':{
            type:Array,
            default: [],
          },
        },
        computed: {
          getGroupedData() {
            let groupSize = 2;
            let groupedData = [];

            for (let i = 0; i < this.productSuperiorityData.length; i += groupSize) {
              groupedData.push(this.productSuperiorityData.slice(i, i + groupSize));
            }
            return groupedData;
          },
          isMobile() {
            return window.innerWidth <= 767;
          },
        },
        data() {
            return {
              data:[],
            }
        },
        methods:{

        }
    }
</script>